import { type RouteRecordRaw } from 'vue-router'

export const PublicationRouter: RouteRecordRaw[] = [
  {
    path: '/publications',
    component: async () => import('./Publications.vue'),
  },
]
